import apiClient from "./client";
import type {
  GetMailRolesParams,
  MailRolesPreviewResponse,
} from "../types/mail";

export const getMailRoles = async (
  params: GetMailRolesParams
): Promise<MailRolesPreviewResponse> => {
  const { data } = await apiClient.get<MailRolesPreviewResponse>(
    "/mail/roles",
    { params }
  );
  return data;
};
